export const contactme = [
    {
        "id":1,
        "name":"Whatsapp",
        "src":"whatsapp.svg",
        "details":"+91 9043571929"
    },
    {
        "id":2,
        "name":"Email",
        "src":"email.svg",
        "details":"anishlp7@gmail.com"
    },
    {
        "id":3,
        "name":"Location",
        "src":"pin.svg",
        "details":"Kanyakumari, India."
    }
];

export const socialIcons = [
    {
        "id":1,
        "name":"Insta",
        "src":"instagram.svg",
        "href":"https://www.instagram.com/anish_l97/"
    },
    {
        "id":2,
        "name":"Facebook",
        "src":"facebook.svg",
        "href":"https://www.facebook.com/anish.lawrence.31/"
    },
    {
        "id":3,
        "name":"LinkedIn",
        "src":"linkedin.svg",
        "href":"https://www.linkedin.com/in/anishlawrence/"
    },
    {
        "id":4,
        "name":"Github",
        "src":"github.svg",
        "href":"https://github.com/anishlp7"
    },
     {
        "id":5,
        "name":"Whatsapp",
        "src":"whatsapp.svg",
        "href":`https://wa.me/919043571929?text=Hi,%20Your%20portfolio%20design%20was%20`
    },
];